module.exports = __webpack_public_path__ + "static/media/golfer-3-a.b63806ee.png";